var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoreElipsis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 11,
    viewBox: "0 0 3 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 9.79095C2.4 10.1615 2.28706 10.458 2.06118 10.6804C1.83529 10.8935 1.54353 11 1.18588 11C0.837647 11 0.555294 10.8935 0.338824 10.6804C0.112941 10.458 0 10.1615 0 9.79095C0 9.42036 0.112941 9.13315 0.338824 8.92933C0.555294 8.71624 0.837647 8.6097 1.18588 8.6097C1.54353 8.6097 1.83529 8.71624 2.06118 8.92933C2.28706 9.13315 2.4 9.42036 2.4 9.79095Z",
    fill: "#6C6C6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 5.4861C2.4 5.85669 2.28706 6.15316 2.06118 6.37552C1.83529 6.58861 1.54353 6.69515 1.18588 6.69515C0.837647 6.69515 0.555294 6.58861 0.338824 6.37552C0.112941 6.15316 0 5.85669 0 5.4861C0 5.11551 0.112941 4.82831 0.338824 4.62448C0.555294 4.41139 0.837647 4.30485 1.18588 4.30485C1.54353 4.30485 1.83529 4.41139 2.06118 4.62448C2.28706 4.82831 2.4 5.11551 2.4 5.4861Z",
    fill: "#6C6C6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4 1.18125C2.4 1.55184 2.28706 1.84832 2.06118 2.07067C1.83529 2.28376 1.54353 2.3903 1.18588 2.3903C0.837647 2.3903 0.555294 2.28376 0.338824 2.07067C0.112941 1.84832 0 1.55184 0 1.18125C0 0.810664 0.112941 0.523458 0.338824 0.319633C0.555294 0.106544 0.837647 0 1.18588 0C1.54353 0 1.83529 0.106544 2.06118 0.319633C2.28706 0.523458 2.4 0.810664 2.4 1.18125Z",
    fill: "#6C6C6C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreElipsis);
export default __webpack_public_path__ + "static/media/more-elipsis.7c8f1903.svg";
export { ForwardRef as ReactComponent };